export default __webpack_public_path__ + "static/media/viatris.63180e9b.png";